import { resolveHeadingColor } from '@/helpers/colorsMapper'

import Markdown from '../../global/Markdown'

export const Subheading = (props: {
  children: any
  className?: string
  color?: string
  displaySubHeading?: boolean
  useNewFonts?: boolean
}): JSX.Element =>
  props.children && props.displaySubHeading ? (
    <div className={props.className}>
      <h2
        style={{ color: resolveHeadingColor(props.color) }}
        className={
          props.useNewFonts ? 'new-text-l-regular' : 'old-title-small-400'
        }
      >
        <Markdown input={props.children} />
      </h2>
    </div>
  ) : (
    <></>
  )
